import { motion } from "framer-motion";
import { MANIFESTO_NUMBERS } from "@/data";
import { useLang } from "@/i18n";

const rise = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 },
  }),
};

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32 border-b border-[#27272A]"
    >
      <div className="grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-4">
          <div className="md:sticky md:top-28">
            <p className="font-satoshi font-bold text-xs tracking-[0.3em] uppercase text-accent mb-6 flex items-center gap-2">
              <span className="w-4 h-4 bg-brand" /> {t.about.label}
            </p>
            <h2 className="font-cabinet font-black uppercase text-5xl md:text-7xl tracking-tighter leading-[0.85]">
              {t.about.title}
            </h2>
            <p className="font-satoshi text-lg text-[#a1a1aa] leading-relaxed mt-8 max-w-xs">
              {t.about.intro}
            </p>
          </div>
        </div>

        <div className="md:col-span-8 flex flex-col border-t border-[#27272A]">
          {t.about.chapters.map((c, i) => (
            <motion.article
              key={i}
              custom={i}
              variants={rise}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`manifesto-${MANIFESTO_NUMBERS[i]}`}
              className="grid grid-cols-[auto,1fr] gap-6 md:gap-12 py-10 md:py-12 border-b border-[#27272A] group"
            >
              <span className="font-cabinet font-black text-6xl md:text-8xl leading-none text-[#27272A] group-hover:text-accent transition-colors duration-300">
                {MANIFESTO_NUMBERS[i]}
              </span>
              <div>
                <h3 className="font-cabinet font-bold uppercase text-2xl md:text-4xl tracking-tight mb-4 text-[#fafafa]">
                  {c.title}
                </h3>
                <p className="font-satoshi text-lg md:text-xl text-[#a1a1aa] leading-relaxed max-w-xl">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
